var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"main"},[_c('p',[_vm._v("注册须知：")]),_c('p',[_vm._v("对不起，清运员身份暂未支持申请产废企业，如有任何疑问请联系平台工作人员")])])])}]

export { render, staticRenderFns }